module.exports = __webpack_public_path__ + "media/images/default/banner_A-b194607962c8cc8505963aa428990647.png";